import React from "react"

import {
	DataGrid,
	GridColDef,
} from "@mui/x-data-grid"

import getTableColumns, { TableInterface } from "./table-columns"

interface AffiliatesTableProps
{
	data: any[]
	onSelectionChanged: (id: string) => void
}
interface AffiliatesTableState
{
}
export class AffiliatesTable
	extends React.Component<AffiliatesTableProps, AffiliatesTableState>
	implements TableInterface
{
	static defaultProps = {}

	private readonly columns: GridColDef[]

	constructor(props: AffiliatesTableProps)
	{
		super(props)
		this.state = {
		}

		this.columns = getTableColumns(this)
	}

	public onRowSelected(id: string): void
	{
		this.props.onSelectionChanged(id)
	}

	render()
	{
		return (
			<DataGrid
				rows={this.props.data}
				autoHeight
				columns={this.columns}
				pageSizeOptions={[5]}
				disableRowSelectionOnClick
				disableColumnMenu={true}
				sx={{bgcolor: "background.default",
					'& .MuiDataGrid-cell:focus': {
						outline: "none"
					}}}
			/>
		)
	}
}
